"use strict";

const CenterFormCtrl = function (CRUDService, Notification, config, $stateParams, $state) {
    var ctrl = this,
    initModel = {
      name: "",
      city: "",
      centerNetwork: [],
      scope: 'QS'
    },
    currentPageNetworks = 0,
    totalPagesNetworks,
    uris = {};

    ctrl.$onInit = function() {

      if ($stateParams.item) {
        ctrl.model = $stateParams.item;
        /*ctrl.model = {
          name: $stateParams.item.name,
          city: $stateParams.item.city,
          scope: $stateParams.item.scope,
          uuid: $stateParams.item.uuid,
          _links: $stateParams.item._links,
          centerNetwork: $stateParams.item.centerNetwork.map(function (network) {
            return network.uuid;
          })
        };*/
        ctrl.model.centerNetwork = $stateParams.item.centerNetwork.map(function (network) {
          return network.uuid;
        });
      } else {
        ctrl.model = initModel;
      }

      CRUDService.getAll(config.urls.networks).then(function (data) {
        totalPagesNetworks = data.page.totalPages;
        ctrl.networks = data._embedded.networks.map(function (item) {
          uris[item.uuid] = item._links.self.href;
          item.uri = item._links.self.href;
          return item;
        });
      });
    };

    ctrl.add = function (form) {
      if (form.$valid) {

        for (var uuid in ctrl.model.centerNetwork) {
          ctrl.model.centerNetwork[uuid] = uris[ctrl.model.centerNetwork[uuid]];
        }

        CRUDService.save(ctrl.model, config.urls.center).then(function () {
          ctrl.model = initModel;
          $state.go('main.settings.center');
        }, function(){
          Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
        });
      }
    };

    ctrl.getNextPageNetworks = function(){
      if ((currentPageNetworks + 1) < totalPagesNetworks) {
        currentPageNetworks++;
        CRUDService.getAll(config.urls.networks, currentPageNetworks).then(function (data) {
          ctrl.networks = ctrl.networks.concat(data._embedded.networks.map(function (item) {
            uris[item.uuid] = item._links.self.href;
            item.uri = item._links.self.href;
            return item;
          }));
        });
      }
    };
  };

CenterFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$state'];

module.exports = {
  template: require('./center-form.html'),
  controller: CenterFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/form-center/form-center.component.js